import { render } from "./Suggestions.vue?vue&type=template&id=67fa3010&scoped=true"
import script from "./Suggestions.vue?vue&type=script&lang=ts"
export * from "./Suggestions.vue?vue&type=script&lang=ts"

import "./Suggestions.vue?vue&type=style&index=0&id=67fa3010&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67fa3010"

export default script